// Hindi (India) translations for Dashboard
console.log('Hindi translation file loaded');
export const hi_IN = {
  // Dashboard Header
  dashboard: "डैशबोर्ड",
  welcomeBack: "वापस स्वागत है! यहाँ आपका व्यापारिक अवलोकन है।",
  
  
  // Loading & Error States
  loadingDashboard: "डैशबोर्ड डेटा लोड हो रहा है...",
  errorLoadingDashboard: "डैशबोर्ड डेटा लोड करने में त्रुटि",
  retry: "पुनः प्रयास",
  
  // Quick Actions Section
  quickActions: "त्वरित कार्य",
  quickActionsDesc: "अपने मुख्य व्यापारिक कार्यों तक पहुँचें",
  sales: "बिक्री",
  purchase: "खरीद", 
  payment: "भुगतान",
  parties: "पार्टियाँ",
  items: "आइटम",
  expenses: "व्यय",
  reports: "रिपोर्ट्स",
  taxes: "कर",
  settings: "सेटिंग्स",
  
  // Todo List Section
  todoList: "कार्य सूची",
  todoListDesc: "अपने दैनिक कार्यों और प्राथमिकताओं का प्रबंधन करें",
  addNewTask: "+ नया कार्य जोड़ें",
  add: "जोड़ें",
  allCategories: "सभी श्रेणियाँ",
  personal: "व्यक्तिगत",
  meeting: "मीटिंग",
  urgent: "तत्काल",
  followUp: "फॉलो अप",
  business: "व्यापार",
  reminder: "अनुस्मारक",
  project: "प्रोजेक्ट",
  other: "अन्य",
  welcomeTodo: "आपकी कार्य सूची में स्वागत है!",
  startOrganizing: "अपने कार्यों को व्यवस्थित करना शुरू करें और उत्पादक बने रहें",
  createFirstTask: "अपना पहला कार्य बनाएं",
  
  // Business Overview Section
  businessOverview: "व्यापारिक अवलोकन",
  businessOverviewDesc: "पूर्ण व्यापारिक मेट्रिक्स और बकाया विवरण",
  show: "दिखाएं",
  hide: "छुपाएं",
  summaryMetrics: "सारांश मेट्रिक्स",
  monthlySales: "मासिक बिक्री:",
  monthlyPurchase: "मासिक खरीद:",
  outstandingBalance: "बकाया शेष:",
  outstandingPayable: "बकाया देय:",
  
  // Outstanding Receivable
  outstandingReceivable: "बकाया प्राप्य",
  moneyOwedToBusiness: "आपके व्यापार पर बकाया धन",
  viewMore: "और देखें",
  lastPayment: "अंतिम भुगतान:",
  noOutstandingReceivables: "कोई बकाया प्राप्य नहीं",
  
  // Outstanding Payable
  outstandingPayable: "बकाया देय", 
  moneyOwedToSuppliers: "आपके आपूर्तिकर्ताओं को बकाया धन",
  noOutstandingPayables: "कोई बकाया देय नहीं",
  
  // Company Information
  companyInformation: "कंपनी की जानकारी",
  gstin: "जीएसटीआईएन:",
  contact: "संपर्क:",
  email: "ईमेल:",
  address: "पता:",
  customers: "ग्राहक:",
  suppliers: "आपूर्तिकर्ता:",
  items: "आइटम:",
  
  // Software Footer
  simplifyingAccounting: "लेखांकन को सरल बनाना, साथ मिलकर",
  allRightsReserved: "सभी अधिकार सुरक्षित।",
  
  // Sales Page
  invoice: "चालान",
  quotation: "कोटेशन",
  receipt: "रसीद",
  selectItem: "आइटम चुनें",
  additionalNotes: "अतिरिक्त नोट्स",
  ewayBillNumber: "ई-वे बिल नंबर दर्ज करें",
  filterByInvoiceNumber: "चालान नंबर से फिल्टर करें",
  filterByPartyName: "पार्टी नाम से फिल्टर करें",
  filterByAmount: "राशि से फिल्टर करें",
  date: "दिनांक",
  party: "पार्टी",
  amount: "राशि",
  paid: "भुगतान",
  outstanding: "बकाया",
  confirmDelete: "हटाने की पुष्टि करें",
  delete: "हटाएं",
  cancel: "रद्द करें",
  addNewItem: "नया आइटम जोड़ें",
  addItem: "आइटम जोड़ें",
  enterItemName: "आइटम का नाम दर्ज करें",
  service: "सेवा",
  goods: "सामान",
  enterCustomUnit: "कस्टम यूनिट दर्ज करें",
  enterHsnCode: "HSN कोड दर्ज करें",
  enterItemDescription: "आइटम का विवरण दर्ज करें",
  addPayment: "भुगतान जोड़ें",
  savePayment: "भुगतान सहेजें",
  enterPaymentAmount: "भुगतान राशि दर्ज करें",
  cash: "नकद",
  cheque: "चेक",
  bankTransfer: "बैंक ट्रांसफर",
  card: "कार्ड",
  additionalNotes: "अतिरिक्त नोट्स",
  paymentReceipts: "भुगतान रसीदें",
  paymentReceiptPreview: "भुगतान रसीद पूर्वावलोकन",
  
  // Purchases Page
  purchaseBill: "खरीद बिल",
  purchaseOrder: "खरीद आदेश",
  selectParty: "पार्टी चुनें",
  partySeller: "पार्टी (विक्रेता)",
  totalAmount: "कुल राशि",
  noItemsUsedYet: "अभी तक कोई आइटम उपयोग नहीं किया गया",
  additionalNotesPurchase: "इस खरीद बिल के लिए अतिरिक्त नोट्स",
  
  // Parties Page
  editParty: "पार्टी संपादित करें",
  addNewParty: "नई पार्टी जोड़ें",
  openingBalanceGuide: "ओपनिंग बैलेंस गाइड",
  positiveValue: "धनात्मक मूल्य:",
  customerOwesYou: "ग्राहक आपका पैसा बकाया है (उधारी/प्राप्य)",
  negativeValue: "ऋणात्मक मूल्य:",
  youOweSupplier: "आप आपूर्तिकर्ता का पैसा बकाया है (अग्रिम/देय)",
  zeroValue: "0:",
  noOpeningBalance: "कोई ओपनिंग बैलेंस नहीं",
  buyer: "खरीदार (ग्राहक)",
  seller: "विक्रेता (आपूर्तिकर्ता)",
  both: "दोनों",
  regular: "नियमित",
  composition: "कंपोजीशन",
  unregistered: "अपंजीकृत",
  fullAddress: "पूरा पता",
  allExistingParties: "सभी मौजूदा पार्टियों को स्वचालित रूप से 'नियमित' GST प्रकार पर सेट किया गया है",
  firmName: "फर्म का नाम",
  personName: "व्यक्ति का नाम",
  type: "प्रकार",
  openingBalance: "ओपनिंग बैलेंस",
  contact: "संपर्क",
  email: "ईमेल",
  whatsapp: "व्हाट्सऐप",
  address: "पता",
  clearSelection: "चयन साफ़ करें",
  viewFullReport: "पूरी रिपोर्ट देखें",
  detailedTransactionHistory: "विस्तृत लेनदेन इतिहास और लेजर प्रविष्टियां देखने के लिए 'पूरी रिपोर्ट देखें' पर क्लिक करें",
  
  // Items Page
  editItem: "आइटम संपादित करें",
  addNewItem: "नया आइटम जोड़ें",
  typeOrSelectUnit: "टाइप करें या यूनिट चुनें",
  enterCustomUnit: "कस्टम यूनिट दर्ज करें",
  goods: "सामान",
  services: "सेवाएं",
  restaurant: "रेस्टोरेंट",
  other: "अन्य",
  baseMaterial: "बेस मैटेरियल",
  consumable: "उपभोग्य",
  packingMaterial: "पैकिंग मैटेरियल",
  itemDescription: "आइटम का विवरण",
  purchasePricePerUnit: "खरीद मूल्य (प्रति यूनिट)",
  salePricePerUnit: "बिक्री मूल्य (प्रति यूनिट)",
  itemName: "आइटम का नाम",
  measurement: "माप",
  type: "प्रकार",
  stock: "स्टॉक",
  
  // Payments Page
  payments: "भुगतान",
  paymentReceipts: "भुगतान रसीदें",
  paymentMode: "भुगतान मोड",
  invoice: "चालान",
  challan: "चालान",
  purchase: "खरीद",
  receipts: "रसीदें",
  viewPaymentReceipts: "भुगतान रसीदें देखें",
  enterAmount: "राशि दर्ज करें",
  additionalNotes: "अतिरिक्त नोट्स",
  backToReceiptsList: "रसीद सूची पर वापस जाएं",
  printUsingBrowser: "ब्राउज़र प्रिंट डायलॉग का उपयोग करके प्रिंट करें",
  downloadAsPDF: "PDF फ़ाइल के रूप में डाउनलोड करें",
  
  // Expenses Page
  fixed: "नियत",
  variable: "परिवर्तनीय",
  labourAdvances: "श्रम/अग्रिम",
  salaries: "वेतन",
  rent: "किराया",
  electricity: "बिजली",
  internet: "इंटरनेट",
  water: "पानी",
  other: "अन्य",
  officeExpense: "कार्यालय व्यय",
  stationery: "स्टेशनरी",
  travel: "यात्रा",
  miscellaneous: "विविध",
  name: "नाम",
  employee: "कर्मचारी",
  labour: "श्रमिक",
  freelancer: "फ्रीलांसर",
  designation: "पदनाम",
  contact: "संपर्क",
  bankName: "बैंक का नाम",
  bankAccountNumber: "बैंक खाता संख्या",
  address: "पता",
  viewDetails: "विवरण देखें",
  edit: "संपादित करें",
  export: "निर्यात करें",
  delete: "हटाएं",
  post: "पद",
  cash: "नकद",
  bankTransfer: "बैंक ट्रांसफर",
  cheque: "चेक",
  card: "कार्ड",
  other: "अन्य",
  advance: "अग्रिम",
  
  // Reports Page
  reportsDashboard: "रिपोर्ट्स डैशबोर्ड",
  selectReportType: "रिपोर्ट प्रकार चुनें",
  partyOptional: "पार्टी (वैकल्पिक)",
  allParties: "सभी पार्टियाँ",
  loadingParties: "पार्टियाँ लोड हो रही हैं...",
  
  // Settings Page
  settings: "सेटिंग्स",
  security: "सुरक्षा",
  mpin: "MPIN",
  login: "लॉगिन",
  back: "वापस",
  verifyCode: "कोड सत्यापित करें",
  enterSixDigitCode: "अपने {verificationMethod} पर भेजे गए 6-अंकीय कोड दर्ज करें",
  securityAndMpin: "सुरक्षा और MPIN",
  setFourDigitMpin: "अतिरिक्त सुरक्षा के लिए 4-अंकीय MPIN सेट करें। यह संवेदनशील कार्यों के लिए आवश्यक होगा।",
  mpinAlreadySet: "MPIN पहले से सेट है",
  enterFourDigitMpin: "4-अंकीय MPIN दर्ज करें",
  confirmMpin: "MPIN की पुष्टि करें",
  setMpin: "MPIN सेट करें",
  verifyCurrentMpin: "वर्तमान MPIN सत्यापित करें",
  enterCurrentMpinToChange: "इसे बदलने के लिए अपना वर्तमान MPIN दर्ज करें",
  forgotMpin: "MPIN भूल गए?",
  chooseVerificationMethod: "अपना MPIN रीसेट करने के लिए सत्यापन विधि चुनें",
  
  // Navigation
  dashboard: "डैशबोर्ड",
  sales: "बिक्री",
  purchases: "खरीद",
  customers: "ग्राहक",
  suppliers: "आपूर्तिकर्ता",
  invoices: "चालान",
  payments: "भुगतान",
  reports: "रिपोर्ट्स",
  settings: "सेटिंग्स",
  items: "आइटम",
  parties: "पार्टियाँ",
  expenses: "व्यय",
  manufacturing: "निर्माण",
  billTemplates: "बिल टेम्प्लेट्स",
  allReports: "सभी रिपोर्ट्स",
  taxes: "कर",
  companyDetails: "कंपनी विवरण",
  employees: "कर्मचारी",
  converter: "कनवर्टर",
  reportToOwner: "मालिक को रिपोर्ट करें",
  reportedIssues: "रिपोर्ट किए गए मुद्दे",
  business: "व्यवसाय",
  company: "कंपनी",
  multiCompany: "मल्टी-कंपनी",
  multiCompanyPlatform: "मल्टी-कंपनी प्लेटफॉर्म"
};

